import React from 'react';
import { useStyles } from './CategoryHeader.styles';
var CategoryHeader = function (_a) {
    var name = _a.name;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("span", null, name)));
};
export { CategoryHeader };
